import { selectUserProjectName } from 'core/userContext';
import { exportCampaignToCSV } from 'modules/campaignIndex/actions';
import { CampaignId } from 'modules/campaignIndex/domainTypes';
import { useDispatch, useSelector } from 'react-redux';

/**
 * Given a list of campaign ids, export the data to a CSV
 * This hook triggers a side effect
 */
export function useExportCampaignsAsCSV(campaignIds: CampaignId[] = []) {
  const projectName = useSelector(selectUserProjectName);
  const dispatch = useDispatch();

  return () => {
    if (campaignIds.length) {
      dispatch(exportCampaignToCSV(campaignIds, projectName));
    }
  };
}
